import { useCallback, useEffect } from 'react';

import { useDebounceCallback } from '@xemplo/hooks';

import { TextareaResize, UseTextareaEventsParams } from './text-area.types';

export function useTextareaEvents({
  textareaRef,
  stretch,
  resize,
}: UseTextareaEventsParams) {
  const resizeTextarea = useCallback(() => {
    if (!textareaRef.current) return;

    const textarea = textareaRef.current;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [textareaRef]);

  const debouncedResize = useDebounceCallback(resizeTextarea, 100);

  const shouldResize = useCallback(() => {
    return stretch && resize === TextareaResize.none;
  }, [stretch, resize]);

  const handleInput = useCallback(() => {
    if (!shouldResize()) return;
    debouncedResize();
  }, [shouldResize, debouncedResize]);

  useEffect(() => {
    if (stretch) {
      resizeTextarea();
    }
  }, [stretch, resizeTextarea, textareaRef]);

  return { handleInput };
}
